import { render } from "./myprofileview.vue?vue&type=template&id=2a82d81c"
import script from "./myprofileview.vue?vue&type=script&lang=js"
export * from "./myprofileview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__